const calculateTooltipSize = (textSize, tooltipSizeProp) => {
    if (textSize === 'bodySmall' || textSize === 'bodyMedium') {
        return 'small';
    }
    return tooltipSizeProp || 'medium';
};

export { calculateTooltipSize };
